export const selectPipeline = (state) => state.pipeline;
